<template>
  <div class="home">
    <div class="title">
      <router-link to="/start"
        ><img src="./../assets/logo.svg" class="title_image"
      /></router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  components: {},
  mounted() {
    setTimeout(function() {
      window.location.href = "#/start";
    }, 2000);
  },
};
</script>

<style lang="scss">
.title {
  margin-top: 40vh;
  min-height: 100vh;
  overflow: hidden;
}
.home {
  color: #fff;
  background-color: #000;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}
a {
  color: #fff;
  text-decoration: none;
}
a:hover {
  color: #fff;
  text-decoration: none;
}
.title_image {
  width: 15%;
}
@media only screen and (max-width: 900px) {
  .title_image {
    width: 30%;
  }
}
</style>
